/**提现列表 A版本 */
const withdrawArrA: any = {
    // 巴西
    BR: [500, 5000, 10000, 20000, 50000, 100000, 200000, 500000, 1000000,],
    // 印尼
    ID: [1000, 3000, 5000, 10000, 20000, 50000, 100000, 200000, 500000],
    // 菲律宾
    PH: [10000, 30000, 50000, 100000, 200000, 500000, 1000000, 2000000, 5000000,],
    // 墨西哥
    ES: [1000, 10000, 50000, 100000, 500000, 1000000],
    // 越南
    VN: [2000, 100000, 500000, 1000000, 2000000, 5000000],
    //埃及
    EG: [10000, 50000, 100000, 200000, 500000, 1000000, 2000000, 5000000, 10000000,],
    // 印度
    IN: [10000, 20000, 50000, 80000, 100000, 200000, 500000, 1000000, 5000000,],
}

/**最后显示的提现列表,B版 */
const lastWithdrawArr: any = {
    // 巴西
    BR: [1000, 5000, 10000, 20000, 50000, 100000, 200000, 500000, 1000000,],
    // 印尼
    ID: [10000, 30000, 50000, 100000, 200000, 500000, 1000000, 2000000, 5000000],
    // 菲律宾
    PH: [10000, 30000, 50000, 100000, 200000, 500000, 1000000, 2000000, 5000000,],
    // 墨西哥
    ES: [1000, 10000, 50000, 100000, 500000, 1000000],
    // 越南
    VN: [2000, 100000, 500000, 1000000, 2000000, 5000000],
    //埃及
    EG: [10000, 50000, 100000, 200000, 500000, 1000000, 2000000, 5000000, 10000000,],
    // 印度
    IN: [1000000, 2000000, 3000000, 4000000, 5000000, 8000000, 10000000, 15000000, 20000000,],
}

/**分享获取下级达到金额可领取奖励 */
const inviteLimitAmount: any = {
    // 巴西
    BR: 3000,
    // 印尼
    ID: 5000,
    // 菲律宾
    PH: 30000,
    // 墨西哥
    ES: 30000,
    // 越南
    VN: 30000,
    //  埃及
    EG: 30000,
    // 印度
    IN: 30000,
}

/**
 * 渠道配置
 */
const channelArr: any = {
    // 巴西
    BR: {
        currencyGold: 'R$',
        currency: 'BRL',
        areaCode: '+55',
        language: 'Portuguese',
        channel: 'BR',
    },
    // 印尼
    ID: {
        currencyGold: 'Rp',
        currency: 'IDR',
        areaCode: '+62',
        language: 'Indonesian',
        channel: 'ID',
    },
    // 菲律宾
    PH: {
        currencyGold: '₱',
        currency: 'PHP',
        areaCode: '+63',
        language: 'English',
        channel: 'PH',
    },
    // 墨西哥
    ES: {
        currencyGold: '$',
        currency: 'MXN',
        areaCode: '+52',
        language: 'Spanish',
        channel: 'ES',
    },
    // 越南
    VN: {
        currencyGold: '₫',
        currency: 'VND',
        areaCode: '+84',
        language: 'Vietnamese',
        channel: 'VN',
    },
    // 埃及
    EG: {
        currencyGold: '£',
        currency: 'EGP',
        areaCode: '+20',
        language: 'Arabic',
        channel: 'EG',
    },
    // 印度
    IN: {
        currencyGold: '₹',
        currency: 'INR',
        areaCode: '+91',
        language: 'English',
        channel: 'IN',
    },
}

/**亏损限制金额 */
const cashbackLimit: any = {
    // 巴西
    BR: 50000,
    // 印尼
    ID: 10000,
    // 菲律宾
    PH: 100000,
    // 墨西哥
    ES: 0,
    // 越南
    VN: 0,
    // 埃及
    EG: 100000,
    // 印度
    IN: 100000,
}

/**进入游戏 金额限制 */
const joinGameLimit: any = {
    BR: 50,
    ID: 500,
    PH: 500,
    EG: 500,
    IN: 500,
}

/**VIP系统 需要达到下注额条件 */
const betLimit: any = {
    BR: 100000,
    ID: 1000000,
    PH: 1000000,
    EG: 1000000,
    IN: 1000000,
}

const vipLimit: any = {
    BR: [1000, 3000],
    ID: [10000, 30000],
    PH: [10000, 30000],
    EG: [10000, 30000],
    IN: [10000, 30000],
}

/**升级vip1需要充值金额 */
const vipChargeNum: any = {
    BR: 1000,
    ID: 3000,
    PH: 20000,
    EG: 1000000,
    IN: 20000,
}

/**升级vip2需要充值金额 */
const vip2ChargeNum: any = {
    BR: 10000,
    ID: 30000,
    PH: 100000,
    EG: 1000000,
    IN: 150000,
}

export {
    withdrawArrA,
    lastWithdrawArr,
    channelArr,
    cashbackLimit,
    inviteLimitAmount,
    joinGameLimit,
    betLimit,
    vipLimit,
    vipChargeNum,
    vip2ChargeNum
}